import React, { useState } from "react";
import "../styles/style.css";
import { FaEnvelope, FaInstagram, FaLinkedin, FaTimes } from "react-icons/fa";

const Engagement = () => {
  const [lightbox, setLightbox] = useState(null);

  const renderCaption = (caption) => {
    const parts = String(caption).split(" · ");
    if (parts.length <= 1) return caption;
    return (
      <>
        {parts.map((part, idx) => (
          <React.Fragment key={`${part}-${idx}`}>
            {idx === 0 ? null : (
              <>
                {" ·"}
                <wbr />{" "}
              </>
            )}
            {part}
          </React.Fragment>
        ))}
      </>
    );
  };

  const placeholders = [
    {
      title: "CSW 70 Event (PDF)",
      caption: "NGO/CSW 70 Parallel Event · 12 March, 2026",
      date: "2026-03-12",
      href: "/documents/csw-70-event.pdf",
      pdfPreview: "/engagement/csw-70-event-preview.jpg",
      imageAlt: "NGO/CSW 70 Parallel Event — Embracing Digital Scholarship to Impact Afghanistan",
    },
    {
      title: "CSW 70 Event (Recording)",
      caption: "NGO/CSW 70 Parallel Event Recording · 12 March, 2026",
      date: "2026-03-12",
      youtubeId: "urUpcyatuuc",
    },
    {
      title: "CSW 70 Event (Flyer)",
      caption: "NGO/CSW 70 Parallel Event · 12 March, 2026",
      date: "2026-03-12",
      imageSrc: "/engagement/csw-70-flyer.png",
      imageAlt: "NGO/CSW 70 Parallel Event flyer",
    },
    {
      title: "United Nations Summit of the Future (Image)",
      caption: "United Nations Summit of the Future · 20 September, 2024",
      date: "2024-09-20",
      imageSrc: "/engagement/un-summit-march-2026.png",
      imageAlt: "United Nations Summit of the Future photo",
    },
    {
      title: "CSW 70 Event (Photos)",
      caption: "Team Meetup at the UN · 6 January, 2026",
      date: "2026-01-06",
      images: [
        {
          src: "/engagement/csw-70-photo-1.png",
          alt: "NGO/CSW 70 Parallel Event photo 1",
        },
        {
          src: "/engagement/csw-70-photo-2.png",
          alt: "NGO/CSW 70 Parallel Event photo 2",
        },
      ],
    },
    {
      title: "UN Summit of the Future (Sept 20, 2025)",
      caption: "United Nations Summit of the Future Action Days · 20 September, 2024",
      date: "2024-09-20",
    },
    {
      title: "UN High-level Meeting (Beijing+30) (Image)",
      caption:
        "UN High-level Meeting (Beijing+30) · 22 September, 2025",
      date: "2025-09-22",
      imageSrc: "/engagement/beijing-plus-30-22-sept-2025.png",
      imageAlt: "UN High-level Meeting (Beijing+30)",
    },
    {
      title: "UN Second World Summit for Social Development (Image)",
      caption: "UN Second World Summit for Social Development (Doha, Qatar) · 4 November, 2025",
      date: "2025-11-04",
      imageSrc: "/engagement/un-second-world-summit-doha-2025.png",
      imageAlt: "UN Second World Summit for Social Development (Doha, Qatar)",
    },
  ];

  const itemsByNewestFirst = [...placeholders].sort((a, b) => {
    const aTime = a.date ? new Date(a.date).getTime() : -Infinity;
    const bTime = b.date ? new Date(b.date).getTime() : -Infinity;
    return bTime - aTime;
  });

  return (
    <div className="page-container">
      <main>
        <div className="engagement-section">
          <div className="engagement-section-text">
            <h2>Engagement</h2>
            <p className="description">
              Explore updates and materials from our team’s engagement work,
              including events, presentations, recordings, and photos. For more
              updates, follow us on{" "}
              <a
                href="https://www.linkedin.com/in/impactafghanistan/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin aria-hidden="true" /> LinkedIn
              </a>{" "}
              and{" "}
              <a
                href="https://www.instagram.com/impactafghanistan1/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram aria-hidden="true" /> Instagram
              </a>
              .
            </p>

            <div className="engagement-grid">
              {itemsByNewestFirst.map((item) => (
                <div className="engagement-card" key={item.title}>
                  <div className="engagement-card-media">
                    {item.title === "UN Summit of the Future (Sept 20, 2025)" ? (
                      <div className="iframe-container">
                        <iframe
                          src="https://docs.google.com/presentation/d/1iRFKWUwe3Gji4jOqaJbAJJSzVeoGc3JSoNqowct2cnI/embed?start=false&loop=false&delayms=15000"
                          title="UN Summit of the Future Action Days - 20 September, 2024"
                          frameBorder="0"
                          allowFullScreen
                        ></iframe>
                        <div className="iframe-caption">{item.caption}</div>
                      </div>
                    ) : item.href && item.href.toLowerCase().endsWith(".pdf") ? (
                      <div className="engagement-media">
                        <a
                          className="engagement-pdf-link"
                          href={item.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`Open ${item.title} (PDF)`}
                        >
                          <img
                            src={item.pdfPreview || item.imageSrc}
                            alt={item.imageAlt || item.title}
                          />
                        </a>
                        <div className="iframe-caption">
                          {renderCaption(item.caption)}
                        </div>
                      </div>
                    ) : item.youtubeId ? (
                      <div className="iframe-container">
                        <iframe
                          src={`https://www.youtube.com/embed/${item.youtubeId}?modestbranding=1&rel=0&iv_load_policy=3&playsinline=1`}
                          title={item.title}
                          frameBorder="0"
                          loading="lazy"
                          referrerPolicy="strict-origin-when-cross-origin"
                          sandbox="allow-scripts allow-same-origin allow-presentation"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                        <div className="iframe-caption">{renderCaption(item.caption)}</div>
                      </div>
                    ) : item.imageSrc ? (
                      <div className="engagement-media">
                        <button
                          type="button"
                          className="engagement-media-button"
                          onClick={() =>
                            setLightbox({ src: item.imageSrc, alt: item.imageAlt || item.title })
                          }
                        >
                          <img src={item.imageSrc} alt={item.imageAlt || item.title} />
                        </button>
                        <div className="iframe-caption">{renderCaption(item.caption)}</div>
                      </div>
                    ) : item.images ? (
                      <EngagementCarousel
                        images={item.images}
                        caption={renderCaption(item.caption)}
                        onOpen={(img) => setLightbox(img)}
                      />
                    ) : item.href ? (
                      <a
                        className="engagement-card-link"
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.title}
                      </a>
                    ) : (
                      <div className="engagement-card-placeholder">
                        <div className="engagement-card-placeholder-title">
                          {item.title}
                        </div>
                        <div className="engagement-card-placeholder-caption">
                          {renderCaption(item.caption)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>

      {lightbox ? (
        <div
          className="lightbox-overlay"
          role="dialog"
          aria-modal="true"
          onClick={() => setLightbox(null)}
        >
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="lightbox-close btn btn-outline-dark"
              onClick={() => setLightbox(null)}
            >
              <FaTimes className="lightbox-close-icon" aria-hidden="true" />
              {" "}
              Close
            </button>
            <div className="lightbox-media">
              <img src={lightbox.src} alt={lightbox.alt || ""} />
            </div>
          </div>
        </div>
      ) : null}

      <footer className="footer">
        <div className="copy">
          &copy; 2024&ndash;{new Date().getFullYear()} Impact Afghanistan - All Rights Reserved.
        </div>
        <div className="bottom-links">
          <div className="links">
            <a href="mailto:impactcompact.afghanistan@gmail.com">
              <FaEnvelope /> impactcompact.afghanistan@gmail.com
            </a>
            <a
              className="icon-link"
              href="https://www.linkedin.com/in/impactafghanistan/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              className="icon-link"
              href="https://www.instagram.com/impactafghanistan1/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Impact Afghanistan on Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

const EngagementCarousel = ({ images, caption, onOpen }) => {
  const [idx, setIdx] = useState(0);
  const current = images[idx] || images[0];
  const total = images.length || 0;

  const prev = () => setIdx((v) => (v - 1 + total) % total);
  const next = () => setIdx((v) => (v + 1) % total);

  if (!current) return null;

  return (
    <div className="engagement-media">
      <div className="engagement-carousel">
        <button
          type="button"
          className="engagement-media-button"
          onClick={() => onOpen?.(current)}
          aria-label="Open image"
        >
          <img src={current.src} alt={current.alt || ""} />
        </button>
        <button
          type="button"
          className="btn btn-outline-dark engagement-carousel-nav engagement-carousel-prev"
          onClick={prev}
          aria-label="Previous image"
        >
          {"<"}
        </button>
        <button
          type="button"
          className="btn btn-outline-dark engagement-carousel-nav engagement-carousel-next"
          onClick={next}
          aria-label="Next image"
        >
          {">"}
        </button>
      </div>
      <div className="iframe-caption">{caption}</div>
    </div>
  );
};

export default Engagement;

